define(function (require) {
    "use strict";

    var JsonUtilities = (function () {

        return {
            /**
             * Parses a valid JSON string into a JSON object.
             * Throws exception if the data parameter is not a valid JSON.
             * @param data The JSON to be parsed
             * @return {*}
             */
            loadJSON: function loadJSON(data) {
                return data && JSON.parse(data) || void 0;
            }
        };

    }());
    return JsonUtilities;
});
